class PreorderPopup extends window.BAOv2.CustomElement {
  static learnMoreSelector = '[data-purple-dot-enabled-form] purple-dot-learn-more span'

  setupListeners () {
    super.setupListeners()

    if (!this.els.dialog.exists) return

    this.listeners.add(document, 'click', this.handleLearnMoreClick.bind(this))
    this.listeners.add(document, 'change', this.handleFormChange.bind(this))
    this.listeners.add(document, 'keyup', this.handleKeyup.bind(this))

    if (this.els.close.exists) {
      this.listeners.add(this.els.close.element, 'click', this.close.bind(this))
    }
  }

  handleLearnMoreClick (event) {
    if (!event.target.closest(PreorderPopup.learnMoreSelector)) return

    this.open()
  }

  handleFormChange (event) {
    if (!event.target.closest('[data-purple-dot-enabled-form]')) return

    this.close()
  }

  handleKeyup (event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    this.close()
  }

  open () {
    this.els.dialog.element.show()
  }

  close () {
    this.els.dialog.element.close()
  }
}

if (!customElements.get('preorder-popup')) {
  customElements.define('preorder-popup', PreorderPopup)
}
